"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CheckedIcon;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@mui/material/SvgIcon"));
function CheckedIcon(props) {
  let path = /*#__PURE__*/_react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "inherit",
    d: "M1005.741 150.947c-24.402-24.408-63.904-24.41-88.308-0.002l-589.653 589.653-221.212-221.212c-24.402-24.408-63.904-24.41-88.308-0.002-24.346 24.348-24.346 63.962 0 88.306l265.369 265.371c24.398 24.396 63.906 24.4 88.306 0l633.807-633.809c24.344-24.346 24.344-63.962 0-88.304z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M1005.741 150.947c-24.402-24.408-63.904-24.41-88.308-0.002l-430.411 430.411v176.612l518.719-518.717c24.344-24.346 24.344-63.962 0-88.304z"
  })));
  return path;
}
